(function () {
  'use strict';

  var mod = document.querySelector('[data-cgny-gmp]');
  var dlg = document.querySelector('[data-cgny-gmr]');
  if (!mod || !dlg) return;

  var form = document.querySelector('form[action*="/cart/add"].product-single__form') || document.querySelector('form[action*="/cart/add"]');
  if (!form) return;
  var addBtn = form.querySelector('button[name="add"], button[type="submit"]');

  // Place the module just above the add to cart button.
  // Without a .payment-buttons wrapper (pre-order pages) it goes right above the button, after the custom size.
  var anchor = addBtn ? (addBtn.closest('.payment-buttons') || addBtn) : null;
  if (anchor && anchor.parentElement) anchor.parentElement.insertBefore(mod, anchor);
  else form.appendChild(mod);
  document.body.appendChild(dlg);
  mod.hidden = false;

  // ---------- example: what the recipient sees ----------
  var gmx = document.querySelector('[data-cgny-gmx]');
  if (gmx) {
    document.body.appendChild(gmx);
    var phone = gmx.querySelector('[data-gmx-phone]');
    var loadingHTML = phone.innerHTML;
    var exFocus = null, exHTML = null;
    var EXAMPLE_URL = '/pages/gift-message-demo?view=gift-embed';
    var mountExample = function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var target = doc.querySelector('[data-cgny-gm]');
      var section = target && (target.closest('.shopify-section') || target.parentElement);
      if (!section) throw new Error('example missing');
      phone.innerHTML = '';
      var node = document.importNode(section, true);
      var scripts = Array.prototype.slice.call(node.querySelectorAll('script'));
      phone.appendChild(node);
      scripts.forEach(function (old) {
        var sc = document.createElement('script');
        if (old.type) sc.type = old.type;
        if (old.src) sc.src = old.src; else sc.textContent = old.textContent;
        old.parentNode.replaceChild(sc, old);
      });
      phone.scrollTop = 0;
    };
    var closeEx = function () {
      gmx.hidden = true;
      phone.innerHTML = loadingHTML;
      document.documentElement.style.overflow = '';
      document.documentElement.classList.remove('cgny-gmr-open');
      if (exFocus && exFocus.focus) exFocus.focus();
    };
    // One sender per opening, alternating between the two of this piece's set (man, woman).
    var examples = (mod.getAttribute('data-gm-ex') || '').split('|').filter(Boolean);
    function nextExample() {
      var n = 0;
      try { n = Number(sessionStorage.getItem('cgny-gm-ex') || 0); sessionStorage.setItem('cgny-gm-ex', String(n + 1)); } catch (e) { n = Math.floor(Math.random() * 2); }
      return examples[n % examples.length] || '';
    }
    mod.querySelector('[data-gmp-example]').addEventListener('click', function () {
      exFocus = document.activeElement;
      phone.setAttribute('data-gmx-video', nextExample());
      phone.innerHTML = loadingHTML;
      gmx.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.classList.add('cgny-gmr-open');
      gmx.querySelector('[data-gmx-close]').focus();
      var get = exHTML ? Promise.resolve(exHTML) : fetch(EXAMPLE_URL, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); });
      get.then(function (html) { exHTML = html; if (!gmx.hidden) mountExample(html); })
        .catch(function () { phone.innerHTML = '<div class="cgny-gmx__loading"><p>The example could not load. Please try again.</p></div>'; });
    });
    gmx.querySelector('[data-gmx-close]').addEventListener('click', closeEx);
    gmx.addEventListener('click', function (e) { if (e.target === gmx || e.target.classList.contains('cgny-gmx__inner')) closeEx(); });
    gmx.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeEx(); });
  }

  var MAX_SECONDS = 59;
  var API = '/apps/circle/gift-message/';
  var card = mod.querySelector('[data-gmp-card]');
  var choose = mod.querySelector('[data-gmp-choose]');
  var ready = mod.querySelector('[data-gmp-ready]');
  var thumb = mod.querySelector('[data-gmp-thumb]');
  var readyLabel = mod.querySelector('[data-gmp-ready-label]');
  var errorBox = mod.querySelector('[data-gmp-error]');
  var readySub = mod.querySelector('.cgny-gmp__ready-sub');
  var actions = mod.querySelector('.cgny-gmp__ready-actions');
  var retryBtn = document.createElement('button');
  retryBtn.type = 'button';
  retryBtn.textContent = 'Try again';
  retryBtn.hidden = true;
  actions.insertBefore(retryBtn, actions.firstChild);
  var bar = document.createElement('span');
  bar.className = 'cgny-gmp__bar';
  bar.setAttribute('aria-hidden', 'true');
  bar.innerHTML = '<i></i>';
  bar.style.cssText = 'display:none;height:2px;margin:2px 0 10px;background:rgba(242,238,230,.25);overflow:hidden';
  bar.firstChild.style.cssText = 'display:block;height:100%;width:0;background:#f2eee6;transition:width .3s ease';
  readySub.parentNode.insertBefore(bar, readySub.nextSibling);
  var modeBtns = Array.prototype.slice.call(mod.querySelectorAll('[data-gmp-mode]'));

  var live = dlg.querySelector('[data-gmr-live]');
  var playback = dlg.querySelector('[data-gmr-playback]');
  var voice = dlg.querySelector('[data-gmr-voice]');
  var vtime = dlg.querySelector('[data-gmr-vtime]');
  var vplay = dlg.querySelector('[data-gmr-vplay]');
  var levels = [];
  var recordingVoice = false;
  var lastSample = 0;
  var wave = dlg.querySelector('[data-gmr-wave]');
  var audioEl = dlg.querySelector('[data-gmr-audio]');
  var stateBox = dlg.querySelector('[data-gmr-state]');
  var stateTitle = dlg.querySelector('[data-gmr-state-title]');
  var stateText = dlg.querySelector('[data-gmr-state-text]');
  var stateActions = dlg.querySelector('[data-gmr-state-actions]');
  var switchBtn = dlg.querySelector('[data-gmr-switch]');
  var timer = dlg.querySelector('[data-gmr-timer]');
  var timeEl = dlg.querySelector('[data-gmr-time]');
  var tip = dlg.querySelector('[data-gmr-tip]');
  var rec = dlg.querySelector('[data-gmr-rec]');
  var progress = dlg.querySelector('[data-gmr-progress]');
  var controls = dlg.querySelector('[data-gmr-controls]');
  var review = dlg.querySelector('[data-gmr-review]');
  var eyebrow = dlg.querySelector('[data-gmr-eyebrow]');

  var mode = 'video';
  var stream = null;
  var recorder = null;
  var chunks = [];
  var startedAt = 0;
  var tick = null;
  var draft = null;     // { blob, url, seconds, mode, poster }
  var message = null;   // the validated message
  var audioCtx = null;
  var analyser = null;
  var raf = null;
  var lastFocus = null;

  function fmt(s) { s = Math.max(0, Math.round(s)); return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0'); }

  function showError(text) { errorBox.textContent = text; errorBox.hidden = !text; }

  // ---------- module state ----------
  // The piece cannot go to the cart while a message is recorded but not yet safely stored.
  function isOn() { return !!message && message.state !== 'saved'; }
  function blockedText() {
    return message && message.state === 'failed'
      ? 'Your message could not be saved. Tap Try again, or remove it to add this piece on its own.'
      : 'Your message is still saving. One moment.';
  }
  function syncDynamic() {
    form.classList.toggle('cgny-gmp-hide-dynamic', !!message);
    document.documentElement.classList.toggle('cgny-gmp-hide-dynamic', !!message);
  }

  modeBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      mode = b.getAttribute('data-gmp-mode');
      openRecorder();
    });
  });

  mod.querySelector('[data-gmp-replace]').addEventListener('click', openRecorder);
  mod.querySelector('[data-gmp-remove]').addEventListener('click', function () { clearMessage(); });
  mod.querySelector('[data-gmp-watch]').addEventListener('click', function () {
    if (!message) return;
    openRecorder(true);
  });

  function clearMessage() {
    if (message && message.xhr) { try { message.xhr.abort(); } catch (e) {} }
    if (message && message.url) URL.revokeObjectURL(message.url);
    message = null;
    ready.hidden = true;
    choose.hidden = false;
    setProperties(null);
    syncCartNote();
    syncDynamic();
  }

  function useMessage(m) {
    if (message && message !== m && message.xhr) { try { message.xhr.abort(); } catch (e) {} }
    message = m;
    choose.hidden = true;
    ready.hidden = false;
    showError('');
    readyLabel.textContent = (m.mode === 'video' ? 'Your video message' : 'Your voice note') + ', ' + fmt(m.seconds);
    if (m.poster) {
      thumb.style.backgroundImage = 'url(' + m.poster + ')';
      thumb.innerHTML = '';
    } else {
      thumb.style.backgroundImage = '';
      thumb.innerHTML = '';
    }
    setProperties(null);
    syncCartNote();
    syncDynamic();
    upload(m);
  }

  // ---------- storing the message ----------
  // start (server prepares a private slot) -> PUT straight to storage -> confirm (server checks it arrived).
  function renderStatus() {
    var m = message;
    if (!m) return;
    var pct = Math.round((m.progress || 0) * 100);
    bar.style.display = m.state === 'saving' ? 'block' : 'none';
    bar.firstChild.style.width = pct + '%';
    retryBtn.hidden = m.state !== 'failed';
    if (m.state === 'saving') readySub.textContent = pct >= 100 ? 'Saving your message, almost done.' : 'Saving your message, ' + pct + '%.';
    else if (m.state === 'saved') readySub.textContent = 'Saved. It travels with this piece. We add the card to the box.';
    else readySub.textContent = 'Not saved yet.';
    if (m.state === 'failed') showError('Your message could not be saved. Check your connection and tap Try again.');
    else if (m.state === 'saved') showError('');
    syncCartNote();
  }

  function postJSON(path, body) {
    return fetch(API + path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw new Error(j.error || ('HTTP ' + r.status)); return j; }); });
  }

  function upload(m) {
    m.state = 'saving'; m.progress = 0;
    renderStatus();
    var type = (m.blob.type || (m.mode === 'video' ? 'video/mp4' : 'audio/mp4'));
    // Chrome labels its H.264 WebM recordings "video/x-matroska"; the file is WebM.
    if (/^video\/x-matroska/.test(type)) type = 'video/webm';
    postJSON('start', { mode: m.mode === 'video' ? 'video' : 'voice', mime: type, size: m.blob.size, seconds: Math.max(1, Math.round(m.seconds)) })
      .then(function (slot) {
        return new Promise(function (resolve, reject) {
          var x = new XMLHttpRequest();
          m.xhr = x;
          x.open('PUT', slot.uploadUrl);
          x.setRequestHeader('Content-Type', slot.contentType);
          x.upload.onprogress = function (e) { if (e.lengthComputable && message === m) { m.progress = e.loaded / e.total; renderStatus(); } };
          x.onload = function () { m.xhr = null; if (x.status >= 200 && x.status < 300) resolve(slot); else reject(new Error('upload ' + x.status)); };
          x.onerror = function () { m.xhr = null; reject(new Error('network')); };
          x.onabort = function () { m.xhr = null; reject(new Error('aborted')); };
          x.send(m.blob);
        });
      })
      .then(function (slot) { return postJSON('confirm', { ref: slot.ref }); })
      .then(function (done) {
        if (message !== m) return;
        m.ref = done.ref;
        m.state = 'saved'; m.progress = 1;
        setProperties(m);
        renderStatus();
      })
      .catch(function () {
        if (message !== m) return;
        m.state = 'failed';
        renderStatus();
      });
  }
  retryBtn.addEventListener('click', function () { if (message && message.state === 'failed') { showError(''); upload(message); } });

  // Line item properties travel with the line to the cart and the order.
  function setProperties(m) {
    Array.prototype.slice.call(form.querySelectorAll('[data-gmp-prop]')).forEach(function (el) { el.remove(); });
    if (!m || !m.ref) return;
    var props = {
      'properties[Gift message]': (m.mode === 'video' ? 'Video' : 'Voice') + ' message, ' + fmt(m.seconds),
      'properties[_gift_ref]': m.ref
    };
    Object.keys(props).forEach(function (name) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = props[name];
      input.setAttribute('data-gmp-prop', '');
      form.appendChild(input);
    });
  }

  var note = null;
  function syncCartNote() {
    if (!addBtn) return;
    if (!note) {
      note = document.createElement('span');
      note.className = 'cgny-gmp-note';
      (addBtn.closest('.payment-buttons') || addBtn.parentElement).appendChild(note);
    }
    note.textContent = message && message.state === 'saved' ? 'Your gift message will be added with this piece.' : '';
    note.hidden = !(message && message.state === 'saved');
  }

  // Block add to cart while a message is recorded but not stored yet. Listening on the document in the
  // capture phase runs before the theme's own add to cart handlers on the button or the form.
  function block(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    showError(blockedText());
    card.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  document.addEventListener('click', function (e) {
    if (!isOn()) return;
    var b = e.target && e.target.closest && e.target.closest('button[name="add"], button[type="submit"], .shopify-payment-button button');
    if (b && (form.contains(b) || b.closest('.shopify-payment-button'))) block(e);
  }, true);
  document.addEventListener('submit', function (e) { if (isOn() && e.target === form) block(e); }, true);

  // ---------- recorder ----------
  // Safari records MP4 with voice and picture in step. Chrome and Firefox only keep them in step in WebM
  // (their MP4 drops the start offset, so lips and voice drift apart); the server turns WebM into MP4 for iPhones.
  var webkit = /AppleWebKit/.test(navigator.userAgent) && !/Chrome|Chromium|Edg|OPR|Android/.test(navigator.userAgent);
  function pickMime(kind) {
    var list = kind !== 'video'
      ? ['audio/mp4', 'audio/webm;codecs=opus', 'audio/webm']
      : webkit
        ? ['video/mp4;codecs=avc1,mp4a', 'video/mp4', 'video/webm;codecs=vp8,opus', 'video/webm']
        : ['video/webm;codecs=h264,opus', 'video/webm;codecs=vp8,opus', 'video/webm', 'video/mp4'];
    if (!window.MediaRecorder || !MediaRecorder.isTypeSupported) return '';
    for (var i = 0; i < list.length; i++) if (MediaRecorder.isTypeSupported(list[i])) return list[i];
    return '';
  }

  function setStage(view) {
    // view: 'wait' | 'live' | 'review'
    stateBox.hidden = view !== 'wait';
    var isVideo = (draft ? draft.mode : mode) === 'video';
    live.hidden = !(view === 'live' && isVideo);
    voice.hidden = !(view === 'live' && !isVideo);
    playback.hidden = !(view === 'review' && isVideo);
    audioEl.hidden = true;
    if (view === 'review' && !isVideo) voice.hidden = false;
    dlg.setAttribute('data-voice', view === 'review' ? 'review' : 'live');
    vplay.hidden = !(view === 'review' && !isVideo);
    controls.hidden = view === 'review';
    review.hidden = view !== 'review';
    timer.hidden = view !== 'live' || !isVideo;
  }

  function openRecorder(playOnly) {
    lastFocus = document.activeElement;
    dlg.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.classList.add('cgny-gmr-open');
    var showing = playOnly === true && message;
    eyebrow.textContent = (showing ? message.mode : mode) === 'video' ? 'A video message' : 'A voice note';
    if (showing) {
      draft = message;
      loadReview(message);
      dlg.querySelector('[data-gmr-use]').textContent = 'Keep this message';
      return;
    }
    dlg.querySelector('[data-gmr-use]').textContent = 'Use this message';
    draft = null;
    startPreview();
    dlg.querySelector('[data-gmr-close]').focus();
  }

  function closeRecorder() {
    stopRecording(true);
    stopStream();
    if (draft && draft !== message && draft.url) URL.revokeObjectURL(draft.url);
    draft = null;
    playback.pause();
    audioEl.pause();
    dlg.hidden = true;
    document.documentElement.style.overflow = '';
    document.documentElement.classList.remove('cgny-gmr-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  dlg.querySelector('[data-gmr-close]').addEventListener('click', closeRecorder);
  dlg.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeRecorder(); });

  function startPreview() {
    eyebrow.textContent = mode === 'video' ? 'A video message' : 'A voice note';
    setStage('wait');
    stateTitle.textContent = '';
    stateText.textContent = mode === 'video' ? 'Allow the camera and microphone when your browser asks.' : 'Allow the microphone when your browser asks.';
    stateActions.hidden = true;
    stateBox.querySelector('.cgny-gmr__ring').hidden = false;
    tip.textContent = 'Speak from the heart. Tap the button to start, and again to stop.';
    rec.disabled = true;
    resetProgress();
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia || !window.MediaRecorder) {
      failPermission('This browser can\'t record', 'Open this page in Safari or Chrome to add a message.', false);
      return;
    }
    var constraints = mode === 'video'
      ? { audio: { echoCancellation: true, noiseSuppression: true }, video: { facingMode: 'user', width: { ideal: 720 }, height: { ideal: 960 } } }
      : { audio: { echoCancellation: true, noiseSuppression: true } };
    var simple = mode === 'video' ? { audio: true, video: true } : { audio: true };
    // Some cameras refuse the preferred settings: try once more with the plainest request.
    navigator.mediaDevices.getUserMedia(constraints).catch(function (err) {
      if (err && (err.name === 'NotAllowedError' || err.name === 'SecurityError')) throw err;
      return navigator.mediaDevices.getUserMedia(simple);
    }).then(function (s) {
      stream = s;
      if (mode === 'video') {
        live.srcObject = s;
        live.play().catch(function () {});
      } else {
        startMeter(s);
      }
      setStage('live');
      timer.hidden = true;
      rec.disabled = false;
      rec.focus();
    }).catch(function (err) {
      var name = err && err.name;
      var device = mode === 'video' ? 'camera' : 'microphone';
      if (name === 'NotAllowedError' || name === 'SecurityError') {
        failPermission('Access is turned off', 'Allow the ' + (mode === 'video' ? 'camera and microphone' : 'microphone') + ' for cynthiagale.com in your browser settings, then try again.', true);
      } else if (name === 'NotFoundError' || name === 'OverconstrainedError') {
        failPermission('No ' + device + ' found', mode === 'video' ? 'This device has no camera we can use. You can record a voice note instead.' : 'This device has no microphone we can use.', true);
      } else {
        failPermission('The ' + device + ' is busy', 'Close any other app or tab using it, then try again.', true);
      }
    });
  }

  function failPermission(title, text, canRetry) {
    setStage('wait');
    stateBox.querySelector('.cgny-gmr__ring').hidden = true;
    stateTitle.textContent = title;
    stateText.textContent = text;
    stateActions.hidden = false;
    dlg.querySelector('[data-gmr-retry]').hidden = !canRetry;
    switchBtn.hidden = mode !== 'video';
    tip.textContent = '';
    rec.disabled = true;
    controls.hidden = true;
  }
  dlg.querySelector('[data-gmr-retry]').addEventListener('click', function () { stopStream(); startPreview(); });
  switchBtn.addEventListener('click', function () { stopStream(); mode = 'audio'; startPreview(); });
  dlg.querySelector('[data-gmr-skip]').addEventListener('click', function () { closeRecorder(); });

  function stopStream() {
    if (raf) cancelAnimationFrame(raf);
    raf = null;
    if (audioCtx) { try { audioCtx.close(); } catch (e) {} audioCtx = null; }
    if (stream) stream.getTracks().forEach(function (t) { t.stop(); });
    stream = null;
    live.srcObject = null;
  }

  // Voice memo: a clean black and white waveform that scrolls past a fixed playhead.
  function startMeter(s) {
    levels = [];
    try {
      var Ctx = window.AudioContext || window.webkitAudioContext;
      audioCtx = new Ctx();
      var src = audioCtx.createMediaStreamSource(s);
      analyser = audioCtx.createAnalyser();
      analyser.fftSize = 1024;
      src.connect(analyser);
      var data = new Uint8Array(analyser.fftSize);
      var draw = function (now) {
        analyser.getByteTimeDomainData(data);
        var sum = 0;
        for (var i = 0; i < data.length; i++) { var v = (data[i] - 128) / 128; sum += v * v; }
        var level = Math.min(1, Math.sqrt(sum / data.length) * 3.2);
        if (recordingVoice && (!lastSample || now - lastSample > 70)) { levels.push(level); lastSample = now; }
        drawLive(level);
        raf = requestAnimationFrame(draw);
      };
      raf = requestAnimationFrame(draw);
    } catch (e) {}
  }

  var BAR = 6, GAP = 4;
  function drawBars(ctx, list, x0, color) {
    var h = wave.height;
    ctx.fillStyle = color;
    for (var i = 0; i < list.length; i++) {
      var bh = Math.max(4, list[i] * (h - 12));
      ctx.fillRect(x0 + i * (BAR + GAP), (h - bh) / 2, BAR, bh);
    }
  }
  function drawLive(level) {
    var ctx = wave.getContext('2d');
    ctx.clearRect(0, 0, wave.width, wave.height);
    var head = Math.round(wave.width * 0.78);
    var fit = Math.floor(head / (BAR + GAP));
    var shown = levels.slice(-fit);
    drawBars(ctx, shown, head - shown.length * (BAR + GAP), '#ffffff');
    // resting dots ahead of the playhead
    ctx.fillStyle = 'rgba(255,255,255,.22)';
    for (var x = head + GAP; x < wave.width; x += BAR + GAP) ctx.fillRect(x, wave.height / 2 - 2, BAR, 4);
    if (!recordingVoice) drawBars(ctx, [Math.max(.04, level)], head - (BAR + GAP), 'rgba(255,255,255,.5)');
  }
  function compress(list, n) {
    if (!list.length) return [];
    var out = [];
    for (var i = 0; i < n; i++) {
      var a = Math.floor(i * list.length / n), b = Math.max(a + 1, Math.floor((i + 1) * list.length / n)), m = 0;
      for (var j = a; j < b && j < list.length; j++) m = Math.max(m, list[j]);
      out.push(m);
    }
    return out;
  }
  function drawReview(list, progress) {
    var ctx = wave.getContext('2d');
    ctx.clearRect(0, 0, wave.width, wave.height);
    var n = Math.floor(wave.width / (BAR + GAP));
    var bars = compress(list, n);
    var cut = Math.round(bars.length * (progress || 0));
    drawBars(ctx, bars.slice(0, cut), 0, '#ffffff');
    drawBars(ctx, bars.slice(cut), cut * (BAR + GAP), 'rgba(255,255,255,.32)');
  }
  function waveformThumb(list) {
    try {
      var c = document.createElement('canvas'); c.width = 240; c.height = 320;
      var g = c.getContext('2d'); g.fillStyle = '#0b0b0b'; g.fillRect(0, 0, 240, 320);
      var bars = compress(list, 22); g.fillStyle = '#ffffff';
      for (var i = 0; i < bars.length; i++) { var bh = Math.max(6, bars[i] * 150); g.fillRect(12 + i * 10, (320 - bh) / 2, 6, bh); }
      return c.toDataURL('image/png');
    } catch (e) { return null; }
  }

  function resetProgress() {
    progress.style.strokeDashoffset = '226.2';
    timeEl.textContent = '0:00';
    if (vtime) vtime.textContent = '0:00';
  }

  rec.addEventListener('click', function () {
    if (recorder && recorder.state === 'recording') stopRecording(false);
    else startRecording();
  });

  function startRecording() {
    if (!stream) return;
    chunks = [];
    var mime = pickMime(mode);
    try {
      recorder = mime ? new MediaRecorder(stream, { mimeType: mime, videoBitsPerSecond: 2500000, audioBitsPerSecond: 96000 }) : new MediaRecorder(stream);
    } catch (e) {
      recorder = new MediaRecorder(stream);
    }
    recorder.ondataavailable = function (e) { if (e.data && e.data.size) chunks.push(e.data); };
    recorder.onstop = finishRecording;
    recorder.start(500);
    startedAt = Date.now();
    if (mode === 'audio') { levels = []; lastSample = 0; recordingVoice = true; }
    rec.classList.add('is-recording');
    rec.setAttribute('aria-label', 'Stop recording');
    timer.hidden = false;
    tip.textContent = 'Recording. Tap to stop when you are done.';
    tick = setInterval(function () {
      var s = (Date.now() - startedAt) / 1000;
      timeEl.textContent = fmt(Math.min(s, MAX_SECONDS));
      if (vtime) vtime.textContent = fmt(Math.min(s, MAX_SECONDS));
      progress.style.strokeDashoffset = String(226.2 * (1 - Math.min(s, MAX_SECONDS) / MAX_SECONDS));
      if (s >= MAX_SECONDS) stopRecording(false);
    }, 200);
  }

  function stopRecording(discard) {
    recordingVoice = false;
    if (tick) clearInterval(tick);
    tick = null;
    rec.classList.remove('is-recording');
    rec.setAttribute('aria-label', 'Start recording');
    if (recorder && recorder.state !== 'inactive') {
      recorder.__discard = !!discard;
      recorder.stop();
    }
  }

  function finishRecording() {
    var r = recorder;
    recorder = null;
    if (r && r.__discard) return;
    var seconds = Math.min((Date.now() - startedAt) / 1000, MAX_SECONDS);
    if (seconds < 1.5) {
      tip.textContent = 'That was very short. Tap the button and record again.';
      resetProgress();
      return;
    }
    var type = (r && r.mimeType) || (mode === 'video' ? 'video/mp4' : 'audio/mp4');
    var blob = new Blob(chunks, { type: type });
    var poster = null;
    if (mode === 'video' && live.videoWidth) {
      var c = document.createElement('canvas');
      c.width = 240; c.height = Math.round(240 * live.videoHeight / live.videoWidth);
      var g = c.getContext('2d');
      g.translate(c.width, 0); g.scale(-1, 1);
      g.drawImage(live, 0, 0, c.width, c.height);
      try { poster = c.toDataURL('image/jpeg', 0.8); } catch (e) { poster = null; }
    }
    var memo = mode === 'audio' ? levels.slice() : null;
    if (memo) poster = waveformThumb(memo);
    stopStream();
    draft = { blob: blob, url: URL.createObjectURL(blob), seconds: seconds, mode: mode, poster: poster, levels: memo };
    loadReview(draft);
  }

  function loadReview(d) {
    setStage('review');
    tip.textContent = 'Watch it back. Happy with it? Use this message, or record again.';
    if (d.mode === 'video') {
      playback.src = d.url;
      playback.currentTime = 0;
      playback.play().catch(function () {});
    } else {
      audioEl.src = d.url;
      if (vtime) vtime.textContent = fmt(d.seconds);
      drawReview(d.levels || [], 0);
      tip.textContent = 'Listen back. Happy with it? Use this message, or record again.';
    }
    dlg.querySelector('[data-gmr-use]').focus();
  }

  function setPlayIcon(playing) {
    vplay.innerHTML = playing
      ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7.5 5.5h3v13h-3zM13.5 5.5h3v13h-3z" fill="currentColor"/></svg>'
      : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l10.5-6.5z" fill="currentColor"/></svg>';
    vplay.setAttribute('aria-label', playing ? 'Pause' : 'Play your message');
  }
  vplay.addEventListener('click', function () {
    if (audioEl.paused) { audioEl.play().catch(function () {}); } else audioEl.pause();
  });
  audioEl.addEventListener('play', function () { setPlayIcon(true); });
  audioEl.addEventListener('pause', function () { setPlayIcon(false); });
  audioEl.addEventListener('ended', function () { setPlayIcon(false); });
  audioEl.addEventListener('timeupdate', function () {
    var d = draft || message;
    if (!d || d.mode !== 'audio') return;
    var dur = isFinite(audioEl.duration) && audioEl.duration ? audioEl.duration : d.seconds;
    drawReview(d.levels || [], Math.min(1, audioEl.currentTime / dur));
    if (vtime) vtime.textContent = fmt(audioEl.currentTime);
  });
  wave.addEventListener('click', function (e) {
    var d = draft || message;
    if (!d || d.mode !== 'audio' || !audioEl.src) return;
    var r = wave.getBoundingClientRect();
    var dur = isFinite(audioEl.duration) && audioEl.duration ? audioEl.duration : d.seconds;
    audioEl.currentTime = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)) * dur;
  });

  dlg.querySelector('[data-gmr-again]').addEventListener('click', function () {
    if (draft && draft !== message && draft.url) URL.revokeObjectURL(draft.url);
    draft = null;
    playback.pause(); audioEl.pause();
    if (message) mode = message.mode;
    startPreview();
  });

  dlg.querySelector('[data-gmr-use]').addEventListener('click', function () {
    if (!draft) return;
    var d = draft;
    if (message && message !== d && message.url) URL.revokeObjectURL(message.url);
    draft = null;
    playback.pause(); audioEl.pause();
    stopStream();
    dlg.hidden = true;
    document.documentElement.style.overflow = '';
    document.documentElement.classList.remove('cgny-gmr-open');
    useMessage(d);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  });
})();
